import { render, staticRenderFns } from "./modalRedirect.vue?vue&type=template&id=6549a7f9&"
import script from "./modalRedirect.vue?vue&type=script&lang=js&"
export * from "./modalRedirect.vue?vue&type=script&lang=js&"
import style0 from "./modalRedirect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports